<template>
    <div class="account-page row m-0 px-2 px-md-3">
        <div
            class="account-navigation col-12 col-md-3 col-lg-3 px-2 py-3 d-flex flex-column align-self-start"
            v-if="navigationVisibleOnMobile || isDesktop"
        >
            <CoMenuItem
                to="/account"
                icon="person"
                :label="$t('labels.general')"
                @click="navigationVisibleOnMobile = false"
            />

            <CoMenuItem
                v-if="plans && $store.state.billingTurnedOn && !$store.state.isInMobile"
                to="/account/plan"
                icon="view-stacked"
                :label="$t('labels.membership')"
                @click="navigationVisibleOnMobile = false"
            />

            <CoMenuItem
                v-if="this.$unleash.isEnabled('frontend.time-pass') && !$store.state.isInMobile"
                to="/account/time-passes"
                icon="clock"
                :label="$t('labels.timepass')"
                @click="navigationVisibleOnMobile = false"
            />

            <CoMenuItem
                v-if="$store.state.billingTurnedOn && !$store.state.isInMobile"
                to="/account/billing/invoices"
                icon="credit-card"
                :label="$t('labels.billing')"
                @click="navigationVisibleOnMobile = false"
            />

            <CoMenuItem
                to="/account/notifications"
                icon="bell"
                :label="$t('labels.notifications')"
                @click="navigationVisibleOnMobile = false"
            />

            <CoAlert
                v-if="$store.state.isInMobile"
                size="md"
                variant="grey"
                class="mt-3"
                :text="$t('messages.moreinfoonourwebsite')"
            />
            <!-- Match the main sidebar's bottom placement while keeping long menus scrollable. -->
            <CoLegalLinks class="footer-info mt-auto py-3 mb-3" />
        </div>

        <div class="col-12 col-md-9 col-lg-6 p-0" v-if="!navigationVisibleOnMobile || isDesktop">
            <div class="d-flex align-items-center d-md-none px-2 mb-3">
                <CoRoundButton icon="chevron-left" variant="secondary" @click="back" />
                <CoText type="p1" variant="mute" class="mb-0 ml-2">{{ $t('labels.back') }}</CoText>
            </div>
            <div class="pb-5">
                <router-view />
            </div>
        </div>
    </div>
</template>

<style lang="less" scoped>
.account-page {
    // Match the spacer in Main.vue, including upgrade headers and admin alerts.
    --account-navigation-top: calc(var(--header-height) + var(--main-alert-offset, 0px) + 4.75rem);
}
.account-navigation {
    position: sticky;
    top: var(--account-navigation-top);
    height: calc(var(--viewport-height, 100vh) - var(--account-navigation-top));
    overflow-y: auto;
    > * {
        flex-shrink: 0;
    }
}
@media screen and (max-width: 992px) {
    .account-page {
        --account-navigation-top: calc(
            var(--mobile-top-nav-height, var(--header-height)) + var(--main-alert-offset, 0px)
        );
    }
}
</style>
<script>
import axios from 'axios';
import CoLegalLinks from '@/components/Molecules/co-legal-links/CoLegalLinks.vue';
import { get } from 'lodash';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoMenuItem from '@/components/Molecules/co-menu-item/CoMenuItem.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';

export default {
    name: 'AccountBase',
    components: {
        CoRoundButton,
        CoText,
        CoMenuItem,
        CoAlert,
        CoLegalLinks,
    },
    data() {
        return {
            plans: null,
            navigationVisibleOnMobile: true,
            windowWidth: 0,

            billingTurnedOn: false,
        };
    },
    computed: {
        isDesktop() {
            return this.windowWidth >= 768;
        },
    },
    mounted() {
        this.getListPlans();

        window.addEventListener('resize', () => {
            this.windowWidth = window.innerWidth;
        });
        this.windowWidth = window.innerWidth;

        // if path is not just /account hide the mobile navigation
        if (this.$route.path !== '/account' && this.$route.path !== '/account/') {
            this.navigationVisibleOnMobile = false;
        }
    },
    methods: {
        back() {
            this.navigationVisibleOnMobile = true;
        },
        goto(path) {
            this.navigationVisibleOnMobile = false;
            this.$router.push(path);
        },
        getListPlans() {
            this.loading = true;
            axios({
                method: 'GET',
                url: '/space/plan/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.plans = response;
                    this.$store.commit('SET_PLANS', get(this.plans, 'data', []));
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                });
        },
    },
};

//  test for the account page
</script>
